import { isTouch } from "../../../_helpers";
import EventsHelper from "../../../_helpers/events";

export default class MatchesFilter {
  $matchunits = null;
  $matchdays = null;
  $filterContainers = null;
  $filters = null;
  $filterButtons = null;
  $mobileFilterOverlay = null;
  $resetButton = null;
  $monthFilter = null;
  $monthCarousels = null;
  $dayAnchors = null;
  $dropdownTexts = null;
  $disclaimer = null;
  scrollOffset = 0;
  filters = {};

  constructor() {
    let _this = this;

    _this.init();
  }

  init() {
    let _this = this;

    _this.$matchunits = $(".vbw-matches--filterable .vbw-mu");
    _this.$matchdays = $(".vbw-matches--data--day");
    _this.$filterContainers = $(".vbw-matches-filters--container");
    _this.$filters = $(".vbw-matches-filters .filters-dropdown");
    _this.$filterButtons = _this.$filters.find("li");
    _this.$mobileFilterOverlay = $(".vbw-matches-filters-overlay");
    _this.$resetButton = $(
      ".vbw-matches-filters .vbw-matches-filters--reset button",
    );
    _this.$monthFilter = $(".vbw-matches-filters--calendar #filters-month li");
    _this.$monthCarousels = $(".vbw-matches--monthcarousel");
    _this.$dayAnchors = $(".day-anchor");
    _this.$dropdownTexts = $(".filters-dropdown-head-text");
    _this.$disclaimer = $(".vbw-matches-filters-disclaimer");
    _this.$localSort = $("[js-matches-sort]");

    _this.scrollOffset += $(".vbw-main-nav").innerHeight() || 0;
    _this.scrollOffset += $(".vbw-secondary-nav").innerHeight() || 0;

    if (!isTouch) {
      _this.handleEvents();
    } else {
      _this.handleMobileEvents();
    }
  }

  handleEvents() {
    let _this = this;

    _this.$filterButtons.click(function () {
      let filterId = $(this).parent("ul").attr("id");
      let filterHeader = _this.$dropdownTexts.filter("#" + filterId + "-text");

      filterHeader.text($(this).text());
      filterHeader.addClass("active");

      _this.filters[filterId] = $(this).attr("value");
      _this.applyFilters();

      $(this).siblings().removeClass("active");
      $(this).addClass("active");
    });

    _this.$resetButton.click(function () {
      _this.$dropdownTexts.each(function () {
        $(this).text($(this).attr("data-original-text"));
      });
      _this.resetFilters();
    });

    _this.$monthFilter.click(function () {
      let filterId = $(this).parent("ul").attr("id");
      _this.$dropdownTexts
        .filter("#" + filterId + "-text")
        .text($(this).text());

      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      _this.updateMonthCarousel("#carousel-" + $(this).attr("value"));
    });

    _this.$dayAnchors.click(function () {
      let day = $(this).find("a").attr("href");

      _this.$dayAnchors.removeClass("active");
      $(this).addClass("active");

      _this.scrollToDay($(day));
    });
  }

  scrollToDay(dayElement) {
    let _this = this;

    $([document.documentElement, document.body]).animate(
      {
        scrollTop: dayElement.offset().top - _this.scrollOffset,
      },
      1000,
    );
  }

  handleMobileEvents() {
    let _this = this;

    _this.$filterContainers.click(function () {
      if ($(this).hasClass("vbw-matches-filters--reset")) {
        return;
      }

      let $filterContent = _this.$mobileFilterOverlay.find(".filter-content");
      $filterContent.empty();
      $filterContent.append($(this).html());
      _this.$mobileFilterOverlay.show();

      _this.$mobileFilterOverlay
        .find("#filter-content-close")
        .click(function () {
          _this.$mobileFilterOverlay.hide();
        });

      $filterContent.find(".filters-dropdown li").removeClass("active");

      $filterContent.find(".filters-dropdown li").click(function () {
        let filterId = $(this).parent("ul").attr("id");
        let filterHeader = _this.$dropdownTexts.filter(
          "#" + filterId + "-text",
        );
        filterHeader.text($(this).text());
        filterHeader.addClass("active");

        if (filterId === "filters-month") {
          _this.updateMonthCarousel("#carousel-" + $(this).attr("value"));
        } else {
          _this.filters[filterId] = $(this).attr("value");
          _this.applyFilters();

          $(this).siblings().removeClass("active");
          $(this).addClass("active");
        }

        _this.$mobileFilterOverlay.hide();
      });
    });

    _this.$resetButton.click(function () {
      _this.$dropdownTexts.each(function () {
        $(this).text($(this).attr("data-original-text"));
      });
      _this.resetFilters();
    });

    _this.$mobileFilterOverlay
      .find(".vbw-matches-filters--reset button")
      .click(function () {
        _this.$dropdownTexts.each(function () {
          $(this).text($(this).attr("data-original-text"));
        });
        _this.resetFilters();
        _this.$mobileFilterOverlay.hide();
      });
  }

  applyFilters() {
    let _this = this;

    _this.$disclaimer.hide();

    let pool = _this.filters["filters-pool"];
    let round = _this.filters["filters-round"];
    let gender = _this.filters["filters-gender"];
    let team = _this.filters["filters-team"];
    let venue = _this.filters["filters-venue"];

    let filterSelector = _this.getFilterSelector(
      pool,
      round,
      gender,
      team,
      venue,
    );

    if (filterSelector) {
      _this.$matchunits.hide();
      _this.$matchunits.filter(filterSelector).show();
    } else {
      _this.$matchunits.show();
    }

    let hiddenMu = _this.$matchunits.filter('[style="display: none;"]');

    if (hiddenMu.length === _this.$matchunits.length) {
      _this.$disclaimer.show();
    }

    _this.$matchdays.show();

    if (_this.$localSort) {
      $(".vbw-matches--data--day").each(function () {
        if (
          !_this.$localSort
            .find(`[data-matchday-wrap='${$(this).attr("id")}']`)
            .children('.vbw-mu--match:not([style="display: none;"])').length
        ) {
          $(this).hide();
        }
      });
    } else {
      _this.$matchdays.each(function () {
        let visibleMu = $(this).siblings(
          '.vbw-mu[data-matchdate="' +
            $(this).attr("id") +
            '"]:not([style="display: none;"])',
        );
        if (!visibleMu.length) {
          $(this).hide();
        }
      });
    }

    let $firstVisibleMu = _this.$matchunits.filter('[style=""]:first');
    let firstSelectionMatchDate = $firstVisibleMu.data("matchdate");

    if (firstSelectionMatchDate) {
      let d = new Date(Date.parse(firstSelectionMatchDate));
      let year = d.getFullYear();
      let month = d.getMonth() + 1;
      let day = d.getDate();

      month = month < 10 ? ["0", month].join("") : month;
      let carouselId = ["carousel-", year, "-", month].join("");

      let $selectedMonthLi = _this.$monthFilter.filter(
        '[value="' + year + "-" + month + '"]',
      );

      _this.$dropdownTexts
        .filter("#filters-month-text")
        .text($selectedMonthLi.text());

      _this.$monthFilter.each(function () {
        $(this).siblings().removeClass("active");
      });
      $selectedMonthLi.addClass("active");
      _this.updateMonthCarousel("#" + carouselId);

      _this.$dayAnchors.removeClass("active");
      _this.$dayAnchors
        .filter('[data-matchdate="' + firstSelectionMatchDate + '"]')
        .addClass("active");

      if (window.CAROUSELS) {
        let carousel = window.CAROUSELS.carousels[carouselId];

        if (carousel) {
          carousel.slideTo(day, 1000);
        }
      }
    }
  }

  resetFilters() {
    let _this = this;
    _this.filters = {};
    $(".vbw-matches--filterable .vbw-mu").show();
    $(".vbw-matches--data--day").show();

    _this.$dropdownTexts.removeClass("active");
    _this.$filters.children().removeClass("active");

    _this.updateMonthCarousel(
      "#carousel-" + _this.$monthFilter.first().attr("value"),
    );
  }

  updateMonthCarousel(selector) {
    let _this = this;

    _this.$monthCarousels.hide();
    _this.$monthCarousels.removeClass("active");
    _this.$monthCarousels.filter(selector).show();
    _this.$monthCarousels.filter(selector).addClass("active");

    EventsHelper.ReloadCarousels();
  }

  getFilterSelector(pool, round, gender, team, venue) {
    let selector = "";

    if (pool) {
      selector += ['[data-pool="', pool, '"]'].join("");
    }
    if (round) {
      selector += ['[data-round="', round, '"]'].join("");
    }
    if (gender) {
      selector += ['[data-gender="', gender, '"]'].join("");
    }
    if (team) {
      selector += ['[data-team*="', team, '"]'].join("");
    }
    if (venue) {
      selector += ['[data-venue="', venue, '"]'].join("");
    }

    return selector;
  }
}
